import { Divider, InfoIconTooltip } from '@/core/features';
import color from '@/core/features/styles/color';

export type SortBarOption = {
    info: {
        htmlInfoText: string;
        htmlInfoTitle: null | string;
    } | null;
    isSelected: boolean;
    label: string;
    name: string;
};

type SortBarProps = {
    onClickOption?: (option: SortBarOption) => void;
    options: Array<SortBarOption>;
};

export default function SortBar({ onClickOption, options }: SortBarProps) {
    return (
        <div className={'flex justify-center items-center'}>
            {options.map((option, index) => {
                const last = index === options.length - 1;
                const showDivider = !last && !options[index + 1]?.isSelected && !option.isSelected;

                return (
                    <div
                        className={'flex justify-center items-center w-full text-14 cursor-pointer overflow-hidden'}
                        key={`${option.name}-${index}`}
                        onClick={() => onClickOption?.(option)}
                        style={{
                            backgroundColor: option.isSelected ? color('foam') : color('white'),
                            borderBottom: option.isSelected
                                ? `2px solid ${color('endeavour')}`
                                : `1px solid ${color('alto')}`,
                            borderTop: `1px solid ${color('alto')}`,
                            // eslint-disable-next-line no-inline-styles/no-inline-styles
                            height: 35,
                        }}
                    >
                        <div className={'flex justify-center items-center gap-x-10 w-full pl-10 pr-10 overflow-hidden'}>
                            <div className={'ellipsis'}>{option.label}</div>
                            {option.info && (
                                <InfoIconTooltip
                                    htmlInfoText={option.info.htmlInfoText}
                                    htmlInfoTitle={option.info.htmlInfoTitle}
                                    iconSize={16}
                                    qaId={'qa-sort-bar-info'}
                                    tippyConfig={{
                                        hideOnClick: false,
                                        placement: 'right',
                                    }}
                                />
                            )}
                        </div>
                        {showDivider && (
                            <Divider
                                color={'alto'}
                                height={20}
                                marginLeft={-1}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
